import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { RangeTimePickerComponent } from '../dashboards/components/range-time-picker/range-time-picker.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { I18NextModule } from 'angular-i18next';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatButtonModule} from '@angular/material/button';
import { TextBoxComponent } from './textbox/textbox.component';
import { DigitDropdownComponent } from './digit-dropdown/digit-dropdown.component';
import { SortIndicatorComponent } from './sort-indicator/sort-indicator.component';
import { FilterPipe } from './Pipes/filterPipe';
import { HtmlDecodePipe } from './Pipes/htmlDecodePipe';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { RouterModule } from '@angular/router';
import { FilterInputComponent } from './basic-components/filter-input/filter-input.component';
import { BasicTextboxComponent } from './basic-components/basic-textbox/basic-textbox.component';
import { BasicTextareaComponent } from './basic-components/basic-textarea/basic-textarea.component';
import { BasicToggleComponent } from './basic-components/basic-toggle/basic-toggle.component';
import { BasicButtonOldComponent } from './basic-components/basic-button-old/basic-button.component';
import { BasicButtonComponent } from './basic-components/basic-button/basic-button.component';
import { BasicCheckboxComponent } from './basic-components/basic-checkbox/basic-checkbox.component';
import { BasicRadioComponent } from './basic-components/basic-radio/basic-radio.component';
import { BasicDropdownComponent } from './basic-components/basic-dropdown/basic-dropdown.component';
import { BasicDateRangePickerComponent } from './basic-date-range-picker/basic-date-range-picker.component';
import { CustomCalendarHeaderComponent } from './basic-date-range-picker/custom-calendar-header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaginatorComponent } from './paginator/paginator.component';
import { SkillTagComponent } from './skill-tag/skill-tag.component';

@NgModule({
imports: [
    CommonModule,
    FormsModule,
    MatMenuModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatButtonModule,
    MatPaginatorModule,
    I18NextModule.forRoot(),
    RouterModule,
    NgSelectModule
],
declarations: [
    TimePickerComponent,
    RangeTimePickerComponent,
    DatePickerComponent,
    TextBoxComponent,
    DigitDropdownComponent,
    SortIndicatorComponent,
    FilterPipe,
    HtmlDecodePipe,
    BreadcrumbsComponent,
    FilterInputComponent,
    BasicTextboxComponent,
    BasicTextareaComponent,
    BasicToggleComponent,
    BasicButtonOldComponent,
    BasicButtonComponent,
    BasicCheckboxComponent,
    BasicRadioComponent,
    BasicDropdownComponent,
    BasicDateRangePickerComponent,
    CustomCalendarHeaderComponent,
    PaginatorComponent,
    SkillTagComponent
],
exports: [
    TimePickerComponent,
    RangeTimePickerComponent,
    DatePickerComponent,
    TextBoxComponent,
    DigitDropdownComponent,
    SortIndicatorComponent,
    FilterPipe,
    HtmlDecodePipe,
    BreadcrumbsComponent,
    FilterInputComponent,
    BasicTextboxComponent,
    BasicTextareaComponent,
    BasicToggleComponent,
    BasicButtonOldComponent,
    BasicButtonComponent,
    BasicCheckboxComponent,
    BasicRadioComponent,
    BasicDropdownComponent,
    BasicDateRangePickerComponent,
    CustomCalendarHeaderComponent,
    PaginatorComponent,
    SkillTagComponent
]
})
export class SharedModule {}
